module.exports = __webpack_public_path__ + "static/media/az.0b4258df.svg";